var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivedSettingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5062 0L15.0125 5.93516C14.5137 6.08479 14.0648 6.33416 13.616 6.58354L7.6808 4.08978L4.08978 7.6808L6.58354 13.616C6.33416 14.1147 6.13466 14.5137 5.93516 15.0125L0 17.5062V22.4938L5.93516 24.9875C6.13466 25.4863 6.33416 25.8853 6.58354 26.384L4.08978 32.3192L7.6808 35.9102L13.616 33.4165C14.0648 33.616 14.5137 33.8653 15.0125 34.0648L17.5062 40H22.4938L24.9875 34.0648C25.4364 33.8653 25.9352 33.6658 26.384 33.4165L32.3192 35.9102L35.9102 32.3192L33.4165 26.384C33.616 25.9352 33.8653 25.4364 34.0648 24.9875L40 22.4938V17.5062L34.0648 15.0125C33.9152 14.5636 33.6658 14.0648 33.4165 13.616L35.9102 7.6808L32.3192 4.08978L26.384 6.58354C25.9352 6.38404 25.4364 6.13466 24.9875 5.93516L22.4938 0L17.5062 0ZM20 12.4688C24.1397 12.4688 27.4813 15.8105 27.4813 19.9501C27.4813 24.0898 24.1397 27.4314 20 27.4314C15.8603 27.4314 12.5187 24.0898 12.5187 19.9501C12.5187 15.8105 15.8603 12.4688 20 12.4688Z",
    fill: "#D94E28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivedSettingIcon);
export default __webpack_public_path__ + "static/media/activedSettingIcon.669488763a3df17f9afee601586226f8.svg";
export { ForwardRef as ReactComponent };